module.exports = __webpack_public_path__ + "static/media/new-background-trees1-00.9d34c3d8.png";